import React from 'react'
import { COLORS } from 'theme'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import AlarmIcon from 'components/icons/AlarmIcon'
import CandidatesIcon from 'components/icons/CandidatesIcon'
import Cancellation from 'components/icons/Cancellation'
import { getDay } from 'utils/getDay'

import { RoleNameFlex, RoleNameDiv } from 'modules/Roles/ViewRole/Style/style'
import {
  FlexWrap,
  Heading,
  Info,
  VerticalDivider,
} from 'modules/Roles/ViewRole/Header/JobDetailsDrawer/Style/style'

const DetailsHeader = ({ tittle, status, jobyType, candidatesCount, date }) => {
  return (
    <FlexWrap gap="15px" column>
      <RoleNameFlex alignCenter>
        <RoleNameDiv>{tittle}</RoleNameDiv>
        <RoleStatus status={status} />
      </RoleNameFlex>

      <FlexWrap alignCenter>
        <FlexWrap gap="5px" alignCenter>
          <AlarmIcon color={COLORS.GREY_T_80} />
          <Info>{jobyType?.split('_')?.join(' ').toLowerCase()}</Info>
        </FlexWrap>

        <VerticalDivider type="vertical" />

        <FlexWrap gap="5px" alignCenter>
          <CandidatesIcon />
          <Info>{candidatesCount}</Info>
        </FlexWrap>

        <VerticalDivider type="vertical" />

        <FlexWrap gap="5px" alignCenter>
          <Cancellation />
          <Heading>Apply before</Heading>
          <Info>{getDay(date, true)}</Info>
        </FlexWrap>
      </FlexWrap>
    </FlexWrap>
  )
}

export default DetailsHeader
